<nb-layout
  [lang]="languageCode">
  <nb-layout-column
    [class]="'align-' + alignment">
    <router-outlet>
    </router-outlet>
  </nb-layout-column>
</nb-layout>